/**
 * Footer newsletter -> Klaviyo (Create Client Subscription).
 * All configuration comes from data-klaviyo-* attributes on the form,
 * which are populated from theme settings (Theme settings > Klaviyo).
 * Public API key only. No storage, cookies or third-party scripts.
 */
(function() {
  'use strict';

  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var CUSTOM_SOURCE = 'Footer newsletter';
  var TOAST_DURATION = 6000;
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var form = document.querySelector('form[data-klaviyo-company-id]');
  if (!form) return;

  var config = {
    companyId: (form.getAttribute('data-klaviyo-company-id') || '').trim(),
    listId: (form.getAttribute('data-klaviyo-list-id') || '').trim(),
    revision: (form.getAttribute('data-klaviyo-api-revision') || '').trim(),
    successMessage: form.getAttribute('data-klaviyo-success-message') || '',
    errorMessage: form.getAttribute('data-klaviyo-error-message') || '',
    invalidEmailMessage: form.getAttribute('data-klaviyo-invalid-email-message') || ''
  };
  if (!config.companyId || !config.listId || !config.revision) return;

  var emailInput = form.querySelector('input[type="email"]');
  var submitBtn = form.querySelector('[data-klaviyo-submit]');
  var consentInput = form.querySelector('[data-klaviyo-consent]');
  var interestInputs = form.querySelectorAll('[data-newsletter-interest]');
  var toast = document.querySelector('[data-klaviyo-toast]');
  var toastTimer = null;
  var isSubmitting = false;

  if (!emailInput || !submitBtn) return;

  function syncSubmitState() {
    var hasConsent = !consentInput || consentInput.checked;
    submitBtn.disabled = isSubmitting || !hasConsent;
  }

  function showToast(message, type) {
    if (!toast || !message) return;
    window.clearTimeout(toastTimer);
    toast.classList.remove('klaviyo-toast--success', 'klaviyo-toast--error', 'is-visible');
    toast.textContent = message;
    toast.classList.add('klaviyo-toast--' + type);
    // Force reflow so the transition replays when a toast is replaced
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    toastTimer = window.setTimeout(function() {
      toast.classList.remove('is-visible');
    }, TOAST_DURATION);
  }

  function setLoading(loading) {
    isSubmitting = loading;
    submitBtn.classList.toggle('is-loading', loading);
    submitBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
    syncSubmitState();
  }

  function getSelectedInterests() {
    var selected = [];
    interestInputs.forEach(function(input) {
      if (input.checked) {
        selected.push(input.getAttribute('data-interest-label'));
      }
    });
    return selected;
  }

  function buildPayload(email) {
    var profileAttributes = {
      email: email,
      subscriptions: {
        email: { marketing: { consent: 'SUBSCRIBED' } }
      }
    };

    var interests = getSelectedInterests();
    if (interests.length) {
      profileAttributes.properties = { interests: interests };
    }

    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: CUSTOM_SOURCE,
          profile: {
            data: {
              type: 'profile',
              attributes: profileAttributes
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: config.listId }
          }
        }
      }
    };
  }

  function onSubmit(evt) {
    // Always stop the native Shopify customer form submit
    evt.preventDefault();
    if (isSubmitting) return;

    var email = emailInput.value.trim();

    if (!EMAIL_PATTERN.test(email)) {
      emailInput.setAttribute('aria-invalid', 'true');
      emailInput.focus();
      showToast(config.invalidEmailMessage, 'error');
      return;
    }
    emailInput.removeAttribute('aria-invalid');

    if (consentInput && !consentInput.checked) {
      consentInput.focus();
      return;
    }

    setLoading(true);

    fetch(ENDPOINT + '?company_id=' + encodeURIComponent(config.companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': config.revision
      },
      body: JSON.stringify(buildPayload(email))
    })
      .then(function(response) {
        // 202 = accepted. 409 = already subscribed/duplicate: same outcome for the visitor.
        if (response.status === 202 || response.status === 409) {
          form.reset();
          showToast(config.successMessage, 'success');
        } else {
          showToast(config.errorMessage, 'error');
        }
      })
      .catch(function() {
        showToast(config.errorMessage, 'error');
      })
      .then(function() {
        setLoading(false);
      });
  }

  if (consentInput) {
    consentInput.addEventListener('change', syncSubmitState);
  }
  // form.reset() fires a reset event before the checkboxes update
  form.addEventListener('reset', function() {
    window.setTimeout(syncSubmitState, 0);
  });
  form.addEventListener('submit', onSubmit);
  syncSubmitState();
})();
